import { Component } from 'vue-property-decorator';
import { divide } from 'lodash';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import ExportFile from '../exportFile';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import imgPreview from '@/views/components/imgPreview';
import { noop } from '@/util';

@DialogFactory
@Component
export default class SearchProduct extends IPSDialog {

    page = 1;

    pageSize = 10;

    total = 0;

    dataList = [];

    keywords = '';

    title = '查找商品ID';

    width = '800px';

    tableSelected = [];

    loadingState = false;

    confirm = false

    siteId = 0

    mounted() {
        this.getDataList();
    }
    onSearchSite(e?) {
        if (e && e.keyCode !== 13) {
            return;
        }
        this.page = 1;
        this.pageSize = 20;
        this.getDataList()
    }
    get exportParams() {
        const postParams = {
            exportType: 'wxLiveViewGoodsList',
            params: {
                keywords: this.keywords,
                pageSize: this.pageSize,
                page: this.page,
                siteId: this.siteId
            },
        };
        return postParams;
    }
    getDataList(value?) {
        const postParams = {
            keywords: this.keywords,
            pageSize: this.pageSize,
            page: this.page,
            siteId: this.siteId
        };
        if (value) {
            postParams['isForget'] = value
        }
        this.loadingState = true
        this.dataList = [];
        IPSService.liveViewProductsList({ postParams }).then((response) => {
            this.loadingState = false
            this.total = response.count;
            this.dataList = response.list;
        });
    }

    onSizeChange(val) {
        this.page = 1;
        this.pageSize = val;
        this.getDataList();
    }

    onPageChange(val) {
        this.page = val;
        this.getDataList();
    }

    onSelected(val) {
        this.tableSelected = val;
        if (this.tableSelected.length === 1) {
            this.confirm = true
        } else {
            this.confirm = false
        }
    }

    onConfirm() {
        const id = this.tableSelected[0].goodsId
        this.$emit('result', id);
        this.$emit('hidden');
    }

    onImgPreview(img) {
        imgPreview.open({ img }).then(noop, noop);
    }
    onCopy(val) {
        Functions.clickCopy(val)
    }
    renderContent(h) {
        return (
            <div class="r-px-20">
                <div class="flex-inline items-center border-bottom-white hei-28 width-100 line-height-56 border-box">
                    <div class="flex-inline items-center hei-16 relative-position fl" style="width:98%">
                        <el-input
                            v-model={this.keywords}
                            placeholder="搜索商品名称"
                            nativeOn-keyup={(e) => {
                                this.onSearchSite(e);
                            }}></el-input>
                        <i class="wid-15 hei-15 top-12 line-height-8 font-size-18 text-grey-15 absolute right-0 cursor-pointer iconfont iconsousuo" onClick={() => this.onSearchSite()}></i>
                    </div>
                    <div class="flex-inline items-center font-size-18 hei-16 relative-position fr">
                        <el-dropdown class="font-center wid-13">
                            <i class="el-icon-more rotate-90"></i>
                            <el-dropdown-menu>
                                <el-dropdown-item>
                                    <ExportFile export-text="导出为Excel" params={this.exportParams} service-url="adminExport" />
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-table key={1} v-loading={this.loadingState} height="350" style="width: 100%" data={this.dataList} ref="multipleTable" on-selection-change={this.onSelected}>
                    <el-table-column type="selection" width="50" align="center" fixed="left" show-overflow-tooltip />
                    <el-table-column type="index" label="#" width="50" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column
                        prop="coverImgUrl"
                        label="图片"
                        width="60px"
                        {...{
                            scopedSlots: {
                                default: (scope) => {
                                    return <img class="wid-16" src={scope.row.coverImgUrl} onClick={this.onImgPreview.bind(this, scope.row.coverImgUrl)} />;
                                },
                            },
                        }}></el-table-column>
                    <el-table-column prop="name" label="商品名称" min-width="200px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goodsId" label="商品ID" show-overflow-tooltip {...{
                        scopedSlots: {
                            default: (scoped) => {
                                return (
                                    <div class="flex-inline items-center">
                                        <span>{scoped.row.goodsId}</span>
                                        <i class="wid-15 font-size-18 text-blue-15 r-ml-14 cursor-pointer el-icon-document-copy" onClick={this.onCopy.bind(this, scoped.row.goodsId)}></i>
                                    </div>
                                );
                            }
                        },
                    }} />


                </el-table>
                <div class="hei-21 r-mt-10 r-py-0 border-bottom-white">
                    <el-button type="primary" onClick={() => { this.getDataList(1) }}>
                        同步商品
                    </el-button>
                    <div class="fr">
                        <el-pagination
                            on-size-change={this.onSizeChange}
                            on-current-change={this.onPageChange}
                            current-page={this.page}
                            page-sizes={[10, 20, 30, 100]}
                            page-size={this.pageSize}
                            pager-count={5}
                            layout="total, sizes, prev, pager, next, jumper"
                            total={this.total}></el-pagination>
                    </div>
                </div>
            </div>
        );
    }
}
